import * as React from "react";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { PlayForFunText } from "../../Keypad/Mobile/components/PlayingForFun";
import { formatTime } from "../Common/Footer.utils";
import { StyledClock } from "./components/Clock";
import { Divider } from "./components/Divider";
import { GameInformation } from "./components/GameInformation";
import { GameName } from "./components/GameName";
import { GameProducer } from "./components/GameProducer";
import { Wrapper } from "./components/Wrapper";
import { IFooterDesktop } from "./FooterDesktop";

export const FooterDesktopDefaultView = ({
  hidden,
  clockAvailable,
  clockDate,
  gameName,
  gameProducer,
  isPlayingForFun,
  t
}: IFooterDesktop) => {
  const showClock = clockAvailable && clockDate && !hidden;

  return (
    <Wrapper hidden={hidden}>
      <GameInformation>
        <GameName data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_GAME_NAME}>
          {gameName}
        </GameName>
        <Divider>|</Divider>
        <GameProducer data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_GAME_PRODUCER}>
          {gameProducer}
        </GameProducer>
      </GameInformation>
      {isPlayingForFun && (
        <PlayForFunText
          dataE2EId={E2EIdentifier.PLAY_FOR_FUN_TITLE}
          text={t("PlayingForFun")}
        />
      )}
      {showClock && (
        <StyledClock data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_CLOCK}>
          {formatTime(clockDate)}
        </StyledClock>
      )}
    </Wrapper>
  );
};
